<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'containerComponents.userSelection.dialog.selectUsers' | translate }}
  </h1>
  <div mat-dialog-content>
    <div [hidden]="noAvailableUsers()">
      <ui-list-filter
        [filtersConfig]="filterConfig"
        (filtersChange)="fetchListBySearchCriteria($event)"
      ></ui-list-filter>
      <mat-table [dataSource]="dataSource" noDataTableMessage>
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.name' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.firstName }} {{ element.lastName }}
            <div class="user-country-flag">
              <span class="flag {{ element.country }}"></span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.email' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.email }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.type' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ 'administration.user.item.userOwnerType.' + element.type | translate }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.selected]="selection.isSelected(row)"
          (click)="selection.toggle(row)"
        ></mat-row>
      </mat-table>

      <mat-paginator #paginator></mat-paginator>
    </div>

    <div *ngIf="noAvailableUsers() && (compartmentUserListFacade.loaded$ | async) && !(loadingFacade.loading$ | async)">
      {{ 'containerComponents.userSelection.dialog.noItems' | translate }}
    </div>
  </div>
  <div mat-dialog-actions class="f-flex-row tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      *ngIf="!noAvailableUsers(); else assignUserToHubTemplate"
      [disabled]="!selection.selected.length"
      [action]="buttonAction.Save"
      [type]="buttonType.Primary"
      (buttonClick)="confirm()"
    ></ui-action-button>
  </div>
</div>

<ng-template #assignUserToHubTemplate>
  <button
    mat-raised-button
    routerLink="/dashboard/administration/users"
    testId="create-button-link"
    (click)="closeDialog()"
  >
    {{ 'common.button.goToUsers' | translate }}
  </button>
</ng-template>
